import styled from 'styled-components'

import { breakpoints } from '@/styles'

export const ContentWrapper = styled.div<{ reverse?: boolean }>`
  font-family: var(--font-open-sans, 'Open Sans', sans-serif);
  margin: 0 auto;

  @media screen and (min-width: ${breakpoints.desktop}) {
    max-width: 1036px;
  }

  @media screen and (min-width: 1211px) {
    max-width: 1151px;
  }

  @media screen and (max-width: ${breakpoints.desktop}) {
    padding: 5px 30px;
  }

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    padding: 5px 20px;
  }
`

export const TabContainer = styled(ContentWrapper)`
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: ${breakpoints.tabletLandscape}) {
    flex-direction: ${props => (props.reverse ? 'column-reverse' : 'column')};
  }
`

export const TabContent = styled.div`
  flex: auto;
  margin-right: 48px;

  @media screen and (max-width: ${breakpoints.tabletLandscape}) {
    margin-right: 0;
  }
`

export const Sidebar = styled.div`
  flex: 0 0 350px;
  margin-top: 0px;

  @media screen and (max-width: ${breakpoints.tabletLandscape}) {
    flex-basis: auto;
  }
`
